<template>
  <div class="teacher-practice-menu navigation-top-app">
    <navigation-top-app
      :app="app"
      :back="back"
    >
      <template v-slot:center>
        <div id="navigation-center">
          {{ app.strings.practice.start.class }}
        </div>
      </template>
    </navigation-top-app>
    <transition name="fade">
      <div id="teacher-practice-start-content" v-if="show && !loading && practice.data.started === 0">
        <practice-class-card class="start-card" :app="app" :practice="practice.data" :student="practice.student" :vehicle="practice.vehicle" :type-name="practice.typeName" />
        <div class="start-fields">
          <label class="km-field" :class="{error: kmError}">
            <span>{{ app.strings.practice.start.km_start }}</span>
            <input ref="kmInput" type="number" inputmode="numeric" min="0" :value="practice.data.km_start || ''" v-on:input="kmChanged('km_start', $event.target.value)" />
            <small v-if="kmError">{{ app.strings.practice.start.empty.km_start }}</small>
          </label>
          <menu-vertical
            class="start-menu"
            :app="app"
            :color="'grey'"
            :bold="true"
            :padding="{
              top: 0,
              sides: 0
            }"
            :options="[
              {
                type: 'select',
                label: practice.evaluation.id === 0 ? app.strings.practice.start.evaluation : practiceEvaluation.key,
                input: {
                  model: practiceEvaluation,
                  options: practiceEvaluations,
                  change: (value) => {
                    updateEvaluation(value.value)
                  }
                }
              }
            ]"
          />
        </div>

        <signature-box class="signature-field start-signature" ref="signaturePad" :app="app" :label="app.strings.practice.start.signature_student" />

        <div class="bottom-action" v-if="canStart === 0">
          <button class="h-button w-100 default-2" v-on:click="start()">
            {{ app.strings.practice.start.start }}
          </button>
        </div>
        <transition name="fade">
          <p class="alert-message danger" v-if="canStart === 1">
            {{ app.strings.practice.start.error.date_yesterday }}
          </p>
          <p class="alert-message danger" v-if="canStart === -1">
            {{ app.strings.practice.start.error.date_nextday }}
          </p>
        </transition>
      </div>
    </transition>
    <transition name="fade">
      <div id="teacher-practice-start-content" v-if="show && !loading && practice.data.started === 1 && ended">
        <practice-class-card class="start-card" :app="app" :practice="practice.data" :student="practice.student" :vehicle="practice.vehicle" :type-name="practice.typeName" />
        <div class="end-fields">
          <label class="km-field" :class="{error: kmError}">
            <span>{{ app.strings.practice.start.km_end }}</span>
            <input ref="kmInput" type="number" inputmode="numeric" min="0" :value="practice.data.km_end || ''" v-on:input="kmChanged('km_end', $event.target.value)" />
            <small v-if="kmError">{{ app.strings.practice.start.empty.km_end }}</small>
            <small class="km-hint" v-else>{{ app.strings.practice.start.km_start }}: {{ practice.data.km_start }}</small>
          </label>
        </div>

        <!-- Grade, signatures and the button: right column on desktop. -->
        <div class="end-side">
          <div class="grade-selector">
            <div class="label">{{ app.strings.practice.start.grade }}</div>
            <div class="grade-options">
              <div v-for="g in [1, 2, 3, 4]" :key="g" class="grade-option" :class="['grade-' + g, {selected: practice.grade === g}]" v-on:click="practice.grade = (practice.grade === g ? 0 : g)">
                {{ app.strings.practice.start.grades[g] }}
              </div>
            </div>
          </div>

          <signature-box class="signature-field end-student-signature" ref="signaturePad" :app="app" :label="app.strings.practice.start.signature_student" />

          <signature-box class="signature-field end-teacher-signature" ref="teacherSignaturePad" :app="app" :label="app.strings.practice.start.signature_teacher" />

          <transition name="fade">
            <p class="alert-message danger" v-if="practice.data.ended === 1">
              {{ app.strings.practice.start.error.ended }}
            </p>
          </transition>
        </div>

        <div class="bottom-action" v-if="practice.data.ended === 0">
          <button class="h-button w-100 danger" v-on:click="endConfirm()">
            {{ app.strings.practice.start.end }}
          </button>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div id="teacher-practice-start-content" v-if="show && loading">
        <loader-dot :size="'16px'" :color_1="'rgb(32, 113, 183)'" :color_2="'rgb(32, 113, 183)'" />
      </div>
    </transition>

    <PracticePerformView ref="practice-perform" :app="app" @onEnd="end" />
  </div>
</template>

<script>
import PracticePerformView from './practice-perform.view'

export default {
  name: 'app-teacher-practice-start-view',
  data () {
    return {
      show: false,
      ended: false,
      kmError: false,
      practice: {
        loading: false,
        grade: 0,
        data: {
          id: 0,
          date: new Date(),
          started: true,
          evaluation: {
            id: 0,
            business_id: 0
          }
        },
        student: {
          code: '',
          first_name: '',
          last_name_1: '',
          last_name_2: ''
        },
        teacher: {
          code: '',
          first_name: '',
          last_name_1: '',
          last_name_2: ''
        },
        vehicle: {
          code: '',
          name: ''
        },
        typeName: '',
        evaluation: {
          id: 0,
          business_id: 0
        }
      },
      evaluation: {
        loading: false,
        data: [],
        student: {
          data: []
        }
      }
    }
  },
  computed: {
    loading () {
      if (this.practice.loading) {
        return true
      }

      if (this.evaluation.loading) {
        return true
      }

      return false
    },
    canStart () {
      return this.yesterDay(new Date(), this.practice.data.date) ? -1 : (this.nextDay(new Date(), this.practice.data.date) ? 1 : 0)
    },
    practiceEvaluations () {
      let evaluations = []

      for (let i in this.evaluation.data) {
        let evaluation = this.evaluation.data[i]
        evaluations.push({
          key: evaluation.name,
          value: evaluation.id + '-' + evaluation.business_id
        })
      }

      return evaluations
    },
    practiceEvaluation () {
      let evaluation = this.evaluation.data.find(evaluation => evaluation.id + '-' + evaluation.business_id === this.practice.data.evaluation.id + '-' + this.practice.data.evaluation.business_id)
      if (evaluation !== undefined) {
        return {
          key: evaluation.name,
          value: evaluation.id
        }
      }

      return {
        key: '',
        value: 0
      }
    }
  },
  props: [
    'app'
  ],
  components: {
    PracticePerformView
  },
  mounted () {
    this.show = true

    this.practice.data.id = this.$route.params.id
    this.practiceRead()
  },
  methods: {
    back () {
      if (this.ended === false) {
        this.$router.push({name: 'app.teacher.practice.menu', params: {id: this.practice.data.id}, query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
      } else if (this.ended === true) {
        this.ended = false
        this.perform()
      }
    },
    // Empty counts as 0, which is what start and end check.
    kmChanged (field, value) {
      this.practice.data[field] = parseInt(value) || 0
      this.kmError = false
    },
    // The problem is told next to the field, not in a dialog.
    showKmError () {
      this.kmError = true
      this.$nextTick(() => {
        if (this.$refs.kmInput) {
          this.$refs.kmInput.focus()
        }
      })
    },
    updateEvaluation (id) {
      this.practice.evaluation.id = id.split('-')[0]
      this.practice.evaluation.business_id = id.split('-')[1]
      this.practice.data.evaluation.id = id.split('-')[0]
      this.practice.data.evaluation.business_id = id.split('-')[1]
    },
    practiceRead () {
      if (this.practice.loading) {
        return
      }

      this.practice.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.practice.read.one + this.practice.data.id,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            this.practice.data = response.body.data.practice
            this.practice.student = response.body.data.student
            this.practice.teacher = response.body.data.teacher
            this.practice.vehicle = response.body.data.vehicle
            this.practice.typeName = (response.body.data.type || {}).name || ''

            this.practice.data.date = new Date(this.practice.data.date)
            this.practice.data.date.setHours(parseInt(this.practice.data.hour), parseInt(this.practice.data.minute), 0, 0)

            this.practice.data.started_at = new Date(this.practice.data.started_at)
            this.practice.data.started_at.setTime(this.practice.data.started_at.getTime() + (this.practice.data.started_at.getTimezoneOffset() * 60 * 1000))

            this.practiceEvaluationReadAll()
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-read-one', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        this.practice.loading = false
      }, () => {
        this.practice.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    practiceEvaluationReadAll () {
      if (this.evaluation.loading) {
        return
      }

      this.evaluation.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.practice.evaluation.read.all + '?student=' + this.practice.student.code,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.evaluation.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.evaluation.data = response.body.data.evaluations
            this.evaluation.student.data = response.body.data.student

            if (this.practice.data.started === 1) {
              this.perform()
            }
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-evaluation-read-all', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.evaluation.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    start () {
      if (!this.practice.data.km_start) {
        this.showKmError()
        return
      }

      if (this.practice.evaluation.id === 0) {
        this.showError(this.app.strings, 'practice-start', this.app.strings.practice.start.empty.evaluation)
        return
      }

      const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/jpeg')
      if (isEmpty) {
        this.showError(this.app.strings, 'practice-start', this.app.strings.practice.start.empty.signature)
        return
      }
      this.practice.data.signature = data

      if (this.practice.loading) {
        return
      }

      this.practice.loading = true

      this.$http.post(
        this.app.url.api + this.app.endpoints.practice.start,
        {
          id: this.practice.data.id,
          evaluation_id: this.practice.evaluation.id,
          evaluation_business_id: this.practice.evaluation.business_id,
          km_start: this.practice.data.km_start,
          signature: data
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.practice.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.perform()
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-start', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.practice.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    },
    perform () {
      if (this.practice.data.started === 0) {
        this.practice.data.started = 1
        this.practice.data.started_at = new Date()
      }
      this.$refs['practice-perform'].open(this.practice, this.evaluation)
    },
    end () {
      this.practice.data.time_real = parseInt(this.diffMinutes(this.practice.data.started_at, new Date()))
      this.practice.data.km_end = this.practice.data.km_start
      this.kmError = false
      this.ended = true
    },
    endConfirm () {
      if (!this.practice.data.km_end || this.practice.data.km_end <= this.practice.data.km_start) {
        this.showKmError()
        return
      }

      const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/jpeg')
      if (isEmpty) {
        this.showError(this.app.strings, 'practice-start', this.app.strings.practice.start.empty.signature)
        return
      }
      this.practice.data.signature = data

      const teacherSignature = this.$refs.teacherSignaturePad.saveSignature('image/jpeg')
      if (teacherSignature.isEmpty) {
        this.showError(this.app.strings, 'practice-end', this.app.strings.practice.start.empty.signature_teacher)
        return
      }

      if (this.practice.loading) {
        return
      }

      this.practice.loading = true

      this.$http.post(
        this.app.url.api + this.app.endpoints.practice.end,
        {
          id: this.practice.data.id,
          time_real: this.practice.data.time_real,
          km_start: this.practice.data.km_end,
          signature: data,
          teacher_signature: teacherSignature.data,
          grade: this.practice.grade
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.practice.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.practice.view = false
            this.$router.push({name: 'app.teacher.practice.menu', params: {id: this.practice.data.id}, query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'practice-start', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.practice.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#teacher-practice-start-content {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 60px;
  padding-bottom: 96px;
  box-sizing: border-box;
}

.km-field {
  display: block;
  margin-bottom: 12px;
}

.km-field > span {
  display: block;
  margin-bottom: 6px;
  color: #64748b;
  font-family: 'Lexend', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.km-field > input {
  width: 100%;
  height: 48px;
  padding: 0 14px;
  box-sizing: border-box;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  background-color: #FFFFFF;
  font-size: 16px;
}

.km-field.error > input {
  border-color: $color-danger;
}

.km-field > small {
  display: block;
  margin-top: 4px;
  color: $color-danger;
  font-size: 13px;
}

.km-field > small.km-hint {
  color: #64748b;
}

.start-card {
  margin: 12px 0;
}

.grade-selector {
  margin-top: 12px;
}

.grade-selector .label {
  margin-bottom: 8px;
  color: #64748b;
  font-family: 'Lexend', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.grade-options {
  display: flex;
  gap: 8px;
}

.grade-option {
  flex: 1;
  padding: 10px 4px;
  border-radius: 12px;
  border: 2px solid #e8edf3;
  background-color: #FFFFFF;
  font-family: 'Lexend', sans-serif;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.grade-option.selected.grade-1 { border-color: $color-danger; color: $color-danger; }
.grade-option.selected.grade-2 { border-color: $color-warning; color: $color-warning; }
.grade-option.selected.grade-3 { border-color: $color-primary-1; color: $color-primary-1; }
.grade-option.selected.grade-4 { border-color: $color-success; color: $color-success; }

@media (min-width: 1024px) {
  // Two columns: the class and its data on the left, grade, signatures and
  // the button on the right.
  #teacher-practice-start-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(360px, 460px);
    column-gap: 28px;
    row-gap: 12px;
    align-content: start;
    align-items: start;
    grid-auto-flow: row dense;
    padding-top: 84px !important;
  }

  #teacher-practice-start-content > * {
    grid-column: 1;
  }

  #teacher-practice-start-content > .grade-selector,
  #teacher-practice-start-content > .signature-field,
  #teacher-practice-start-content > p {
    grid-column: 2;
  }

  // Before starting: explicit rows, so the signature (right) does not stretch
  // the rows of the left column and leave gaps.
  #teacher-practice-start-content > .start-card {
    grid-row: 1;
  }

  #teacher-practice-start-content > .start-card ~ .start-fields {
    grid-row: 2 / span 3;
  }

  #teacher-practice-start-content > .start-signature {
    grid-row: 1;
    margin-top: 0;
  }

  #teacher-practice-start-content > .start-fields ~ p {
    grid-row: 2;
  }

  #teacher-practice-start-content > .start-fields ~ p.alert-message {
    grid-row: 3;
  }

  // Ending: grade, both signatures and the button stacked on the right.
  #teacher-practice-start-content > .start-card ~ .end-fields {
    grid-row: 2 / span 4;
  }

  #teacher-practice-start-content > .end-side {
    grid-column: 2;
    grid-row: 1 / span 5;
  }

  .end-side > .grade-selector {
    margin-top: 0;
  }
}
</style>
